import React, { useMemo } from 'react';
import { Typography, Row, Col } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { CSVError } from 'works/legacy/lib/csv_error';

const { Title, Text } = Typography;

const errorLabels: { [key: string]: string } = {
  blank: 'Missing Data',
  invalid: 'Invalid Data',
  unauthorized: 'Permissioning Issues',
};

type Props = {
  errors: CSVError[];
};

export function MembersAddMultipleReviewErrors({ errors }: Props) {
  const groupedErrors = useMemo(
    () =>
      errors.reduce(
        (
          acc: { [type: string]: { [row: number]: CSVError[] } },
          current: CSVError
        ) => {
          if (!acc[current.type]) {
            acc[current.type] = {};
          }

          if (!acc[current.type][current.row]) {
            acc[current.type][current.row] = [];
          }

          acc[current.type][current.row].push(current);

          return acc;
        },
        {}
      ),
    [errors]
  );

  return (
    <div>
      {Object.entries(groupedErrors).map(([type, rows]) => (
        <div key={type}>
          <Title level={2}>{errorLabels[type]}</Title>
          {Object.entries(rows).map(([row, errors]) => (
            <Row key={row} gutter={[0, 8]}>
              <Col span={3}>
                <Text style={{ color: Colors.midnightLighter }}>Row {row}</Text>
              </Col>
              <Col span={21}>
                {errors.map(({ message }) => (
                  <Row key={message}>
                    <Col>
                      <Text>{message}</Text>
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </div>
  );
}
